export const ESTIMATES = 'ESTIMATES';
export const ESTIMATES_BUSY = 'ESTIMATES_BUSY';
export const ESTIMATES_CREATE_BUSY = 'ESTIMATES_CREATE_BUSY';
export const ESTIMATES_AUTH_BUSY = 'ESTIMATES_AUTH_BUSY';
export const SELECTED_ESTIMATE = 'SELECTED_ESTIMATE';
export const SELECTED_ESTIMATE_DATA = 'SELECTED_ESTIMATE_DATA';
